import React from "react";

const ReportCard = ({ title, value, subtitle, children }) => {
  return (
    <div className="report-card">
      <div>
        <p className="report-card-label">{title}</p>
        <p className="report-card-value">{value}</p>
        {subtitle && <p className="report-card-subtitle">{subtitle}</p>}
      </div>
      {children && <div className="report-card-extra">{children}</div>}
    </div>
  );
};

export default ReportCard;
